import React from 'react';
import {
  CandidateEngagementsConst,
  CandidateOpportunitiesConst,
} from '@axiom/const';
import {
  Accolade,
  Badge,
  CardSection,
  CondensedHeader,
  Gutter,
  Icon,
  ReadonlyTextarea,
} from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { SubmissionDetails } from '../SubmissionDetails/SubmissionDetails';
import { EngagementProgressSteps } from '../EngagementProgressSteps/EngagementProgressSteps';

const { CandidateStatuses } = CandidateOpportunitiesConst;

const { Interested } = CandidateStatuses;

export type SubmissionsViewDetailsProps = {
  submission: CandidateEngagementDetails;
  name?: string;
};
export const SubmissionsViewDetails = ({
  submission,
  name = 'SUBMISSIONS_VIEW_DETAILS',
}: SubmissionsViewDetailsProps) => {
  return (
    <CardSection name={name} divider>
      {submission.engagementState ===
      CandidateEngagementsConst.EngagementStates.Warmed ? (
        <Gutter bottom="24px">
          <Badge background="forest green" name="WARMED_NEW_BADGE">
            New
          </Badge>
        </Gutter>
      ) : null}
      {submission.opportunity.selfService ? (
        <Gutter bottom="24px">
          <Accolade
            color="purple"
            label="Self-service"
            name="SELF_SERVICE_ACCOLADE"
          >
            <Icon name="star-filled" />
          </Accolade>
        </Gutter>
      ) : null}
      {submission.candidateStatus === Interested ? null : (
        <Gutter bottom="24px">
          <EngagementProgressSteps
            engagement={submission}
            name="ENGAGEMENT_VIEW_PROGRESS_STEPS"
          />
        </Gutter>
      )}
      <SubmissionDetails name="SUBMISSION_DETAILS" submission={submission} />
      <Gutter bottom="16px" />
      <CondensedHeader>Work Description</CondensedHeader>
      <Gutter bottom="4px" />
      <ReadonlyTextarea
        value={submission.position?.description || '--'}
        name="WORK_DESCRIPTION"
        formatting="modern"
      />
    </CardSection>
  );
};
